import { spacing4x } from "@airhelp/design-tokens";
const baseStyle = {
    fontSize: "sm",
    fontWeight: "bold",
    textTransform: "none",
    padding: spacing4x,
    whiteSpace: "normal",
    width: {
        base: "100%",
        md: "fit-content",
    },
    div: {
        color: "primary.500",
    },
};
const variantBasic = {
    background: {
        base: "primary.200",
        md: "transparent",
    },
};
const variants = {
    basic: variantBasic,
};
const defaultProps = {
    variant: "basic",
};
const Badge = {
    baseStyle,
    variants,
    defaultProps,
};
export default Badge;
